import { strapiClient } from '..';
import { mappingBanners, mappingHomeBanners } from './index.mapping';
class StrapiService {
    async Home(data: { lang: string }) {
        const response = await strapiClient.get(`home?locale=${data.lang}&populate[Slider][populate]=*`);
        return response.data;
    }
    async HomeFlight(data: { lang: string }) {
        const response = await strapiClient.get(`home-flight?locale=${data.lang}`);
        return response.data;
    }
    async City(data: { lang: string; slug: string }) {
        const response = await strapiClient.get(
            `cities?locale=${data.lang}&filters[Slug]=${data.slug}&populate[HeadImage][populate]=*&populate[Feature][filters][Show]=true&populate[Category][populate][Post][populate]=Image&populate[Category][populate][Post][filters][Show]=true[populate]=*&populate[BlogImage][populate]=*&populate[Faq][populate]=*&populate[Seo][populate]=*`
        );
        return response.data;
    }
    async AllCity(data: { lang: string }) {
        const response = await strapiClient.get(`cities?locale=${data.lang}&populate[HeadImage][populate]=*`);

        return response.data;
    }
    async AllBusCity(data: { lang: string }) {
        const response = await strapiClient.get(`bus-cities?locale=${data.lang}&populate[HeadImage][populate]=*`);

        return response.data;
    }
    async BusCity(data: { lang: string; slug: string }) {
        const response = await strapiClient.get(
            `bus-cities?locale=${data.lang}&filters[Slug]=${data.slug}&populate[HeadImage][populate]=*&populate[Feature][filters][Show]=true&populate[Faq][populate]=*&populate[Seo][populate]=*&populate[FromBusPopularRoute][populate]=*&populate[ToBusPopularRoute][populate]=*`
        );
        return response.data;
    }
    async Destination(data: { lang: string; fromSlug: string; toSlug: string }) {
        const response = await strapiClient.get(
            `destinations?locale=${data.lang}&filters[FromSlug]=${data.fromSlug}&filters[ToSlug]=${data.toSlug}&populate[Faq][populate]=*&populate[Post][populate]=*&populate[Seo][populate]=*`
        );
        return response.data;
    }
    async AllDestination(data: { lang: string }) {
        const response = await strapiClient.get(`destinations?locale=${data.lang}`);

        return response.data;
    }
    async BusDestination(data: { lang: string; fromSlug: string; toSlug: string }) {
        const response = await strapiClient.get(
            `bus-destinations?locale=${data.lang}&filters[FromSlug]=${data.fromSlug}&filters[ToSlug]=${data.toSlug}&populate[Faq][populate]=*&populate[FromBusPopularRoute][populate]=*&populate[BusPopularRoute][populate]=*&populate[BusCheapestRoute][populate]=*&populate[ToBusPopularRoute][populate]=*&populate[Seo][populate]=*`
        );
        return response.data;
    }
    async AllBusDestination(data: { lang: string }) {
        const response = await strapiClient.get(`bus-destinations?locale=${data.lang}`);

        return response.data;
    }
    async BusCompanies(data: { lang: string; slug: string }) {
        const response = await strapiClient.get(
            `bus-companies?locale=${data.lang}&filters[Slug]=${data.slug}&populate[Faq][populate]=*&populate[BusPopularRoute][populate]=*&populate[Seo][populate]=*`
        );
        return response.data;
    }
    async BusStations(data: { lang: string; slug: string }) {
        const response = await strapiClient.get(
            `bus-stations?locale=${data.lang}&filters[Slug]=${data.slug}&populate[Faq][populate]=*&populate[BusPopularRoute][populate]=*&populate[Seo][populate]=*`
        );
        return response.data;
    }
    async Faq(data: { lang: string; category: string; post: string }) {
        const tempCategory = data.category
            ? `&filters[Slug]=${data.category}&populate[Post]=*&populate[Seo][populate]=*`
            : '';
        const tempPost = data.post
            ? `&filters[Slug]=${data.category}&populate[Post][filters][Slug]=${data.post}&populate[Post][populate]=*`
            : '';

        const url = tempPost ? tempPost : tempCategory;

        const response = await strapiClient.get(`faqs?locale=${data.lang}${url}`);

        const temp = response.data;
        return tempCategory || tempPost ? temp.data[0].attributes : temp.data;
    }
    async FaqSearch(data: { lang: string; search: string }) {
        const response = await strapiClient.get(
            `faqs?locale=${data.lang}&populate[Post][filters][Title][$contains]=${data.search}`
        );
        const temp = response.data;
        let tempData: any = [];
        temp.data?.map((item: any) => {
            item.attributes.Post?.map((items: any) => {
                tempData.push({ ...items, categorySlug: item.attributes.Slug });
            });
        });
        return tempData;
    }
    async FaqSiteMap() {
        const response = await strapiClient.get(
            `faqs?locale=all&fields=locale&fields=Slug&populate[Post][fields]=Slug`
        );
        return response.data;
    }
    async CitySiteMap() {
        const response = await strapiClient.get(
            `cities?locale=all&fields=locale&fields=Slug&populate[Post][fields]=Slug`
        );
        return response.data;
    }
    async BusCitySiteMap() {
        const response = await strapiClient.get(
            `bus-cities?locale=all&fields=locale&fields=Slug&populate[Post][fields]=Slug`
        );
        return response.data;
    }
    async DestinationSiteMap() {
        const response = await strapiClient.get(
            `destinations?locale=all&fields=locale&fields=FromSlug&fields=ToSlug&populate[Post][fields]=*`
        );
        return response.data;
    }
    async BusDestinationSiteMap() {
        const response = await strapiClient.get(
            `bus-destinations?locale=all&fields=locale&fields=FromSlug&fields=ToSlug&populate[Post][fields]=*`
        );
        return response.data;
    }
    async BusCompaniesSiteMap() {
        const response = await strapiClient.get(
            `bus-companies?locale=all&fields=locale&fields=Slug&populate[Post][fields]=Slug`
        );
        return response.data;
    }
    async BusStationsSiteMap() {
        const response = await strapiClient.get(
            `bus-stations?locale=all&fields=locale&fields=Slug&populate[Post][fields]=Slug`
        );
        return response.data;
    }

    async NewBanners({
        category,
        subCategory,
        filters = {
            fromCode: '',
            toCode: '',
        },
        lang,
    }: {
        category: string;
        subCategory: string;
        filters?: {
            fromCode?: string;
            toCode?: string;
            travelType?: 'abroad' | 'domestic';
        };
        lang: string;
    }) {
        let responseUrl = `banners?locale=${lang}&filters[Category][$eq]=${category}&filters[SubCategory][$eq]=${subCategory}&populate[Image][fields]=url&populate[ResponsiveImage][fields]=url&filters[Platform][$eq]=all&filters[Platform][$eq]=web`;

        const response = await strapiClient.get(responseUrl);

        return mappingBanners(response.data?.data || [], filters);
    }

    async HomeBanners({
        where,
        lang,
    }: {
        where: 'Home' | 'Flight' | 'Bus' | 'Hotel' | 'Car' | 'Support';
        lang: string;
    }) {
        let responseUrl = `home-banner?locale=${lang}&populate[${where}][populate][image][fields]=url&populate[${where}][populate][responsiveImage][fields]=url`;

        const response = await strapiClient.get(responseUrl);

        return mappingHomeBanners(response.data?.data?.attributes?.[`${where}`] || [], where);
    }

    async GetContractDetails({
        where,
        lang,
    }: {
        where: 'lightingText' | 'cookiePolicy' | 'userAggrement' | 'gdpr';
        lang: string;
    }) {
        let responseUrl = `contract?locale=${lang}&populate[${where}][populate]=*`;

        const response = await strapiClient.get(responseUrl);

        return response.data?.data?.attributes?.[`${where}`] || undefined;
    }
}

const strapiService = new StrapiService();

export default strapiService;
